/** Permission names as stored in the database (`permissions.name`) */
export const PERMISSIONS = {
  CAN_VIEW_STATISTICS: 'canViewStatistics',
  CAN_ACCESS_WEB_USERS: 'canAccessWebUsers',
  CAN_MANAGE_WEB_ACCESS: 'canManageWebAccess',
  CAN_ACCESS_CONFIGURATIONS: 'canAccessConfiguration',
  CAN_CREATE_DRIVES: 'canCreateDrives',
  CAN_ACCESS_DRIVERS: 'canAccessDrivers',
  CAN_DELETE_DRIVERS: 'canDeleteDrivers',
  CAN_DEACTIVATE_DRIVER_ACCOUNT: 'canDeactivateDriverAccount',
  CAN_EDIT_DRIVERS: 'canEditDrivers',
  CAN_ACCESS_CARS: 'canAccessCars',
  CAN_DELETE_CARS: 'canDeleteCars',
  CAN_EDIT_CARS: 'canEditCars',
  CAN_EDIT_STANDS: 'canEditStands',
  CAN_DELETE_STANDS: 'canDeleteStands',
  CAN_MANAGE_ADS: 'canManageAds',
};
